import { render, staticRenderFns } from "./TotalBoxOfficeList.vue?vue&type=template&id=231a02b3&scoped=true"
import script from "./TotalBoxOfficeList.vue?vue&type=script&lang=js"
export * from "./TotalBoxOfficeList.vue?vue&type=script&lang=js"
import style0 from "./TotalBoxOfficeList.vue?vue&type=style&index=0&id=231a02b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231a02b3",
  null
  
)

export default component.exports